.root {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  min-width: 30rem;
  min-height: 45rem;
  padding: 2.4rem;
}

.bottomWrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
}
